/**
 * Pantalla de prueba para ErrorScreenMC
 * Solo accesible para usuarios super_admin (verificado en ProtectedRoute)
 * 
 * Accede a: /retailers/{tu-slug}/test-error
 */
import React from 'react';
import ErrorScreenMC from '../components/ErrorScreenMC';

const TestErrorScreenMC = () => {
  return (
    <ErrorScreenMC
      errorMessage="Error 500: Internal Server Error - No se pudo cargar la información del servidor"
      errorStack={`Error: Failed to fetch
    at fetchData (httpService.js:34:15)
    at CustomersScreen.loadCustomers (CustomersScreen.js:45:20)
    at async Promise.all`}
      currentUrl={window.location.href}
    />
  );
};

export default TestErrorScreenMC;
